import { AssetStoryblok, StoryblokImage } from "@wojo/storyblok";
import { Markdown, Modal, ModalBody, ModalProps, Text } from "@wojo/ui";
import React from "react";
import style from "./TourHeroSummaryInfo.module.scss";

export type TourHeroSummaryModalProps = Pick<
    ModalProps,
    "isOpen" | "onCloseRequested"
> & {
    icon?: AssetStoryblok | null;
    iconWidth?: string;
    heading: string;
    description: string;
    accessibleTitle: string;
};

export const TourHeroSummaryInfoModal: React.FC<
    React.PropsWithChildren<TourHeroSummaryModalProps>
> = ({
    isOpen,
    onCloseRequested,
    icon,
    iconWidth,
    heading,
    description,
    accessibleTitle,
}) => {
    return (
        <Modal
            isOpen={isOpen}
            onCloseRequested={onCloseRequested}
            closeOnOutsideClick={true}
            accessibleTitle={accessibleTitle}
        >
            <ModalBody>
                <Text.Heading
                    order="3"
                    tag="h2"
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "var(--g-spacing-sm)",
                    }}
                >
                    {icon?.filename && (
                        <StoryblokImage
                            mobile={{
                                asset: icon,
                            }}
                            style={{
                                width: iconWidth,
                            }}
                            className={style["summary-icon"]}
                        />
                    )}
                    {heading}
                </Text.Heading>
                {!!description && (
                    <Markdown
                        style={{ marginTop: "var(--g-spacing-sm)" }}
                        markdown={description}
                    />
                )}
            </ModalBody>
        </Modal>
    );
};
